<template>
  <div class="company-wall-details-portfolio-skeleton">
    <div class="company-wall-details-portfolio-skeleton__tabs">
      <PSkeleton height="18px" width="120px" />
      <PSkeleton height="18px" width="90px" />
      <PSkeleton height="18px" width="120px" />
    </div>
    <PDivider />
    <SAlbumsSkeleton />
  </div>
</template>

<script setup lang="ts">
import { PDivider, PSkeleton, SAlbumsSkeleton } from "@solvari/components";
</script>

<style scoped lang="postcss">
.company-wall-details-portfolio-skeleton {
  &__tabs {
    @apply mt-8 flex gap-8;
  }
  &__content {
    @apply flex gap-6;
  }
}
</style>
